import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw, { styled } from 'twin.macro'

const StyledShareContactWrapper = styled.div<{
  canShare: boolean
  isProperty: boolean
}>(({ canShare, isProperty }) => [
  tw`col-span-full flex flex-col-reverse justify-center space-y-px-32 mt-px-24 md:(flex-row col-start-10 col-span-2 space-y-0 space-x-px-32 mt-0) ml:(space-x-px-48) lg:(col-start-9 justify-start mt-px-64)`,
  canShare && tw`mt-0 md:(mt-px-40) `,
  isProperty && tw`md:(mt-px-24) lg:(mt-px-64)`,
  isProperty && canShare && tw`md:(mt-px-48)`,
])

export const ShareContactWrapper: FunctionComponent<React.PropsWithChildren<{
  canShare: boolean
  isProperty: boolean
}>> = ({ canShare, isProperty, children }) => {
  return (
    <StyledShareContactWrapper canShare={canShare} isProperty={isProperty}>
      {children}
    </StyledShareContactWrapper>
  )
}
